/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ImageSize = {
    Auto: 'Auto',
    Size1024X1024: 'Size1024X1024',
    Size1024X1536: 'Size1024X1536',
    Size1536X1024: 'Size1536X1024'
} as const;
export type ImageSize = typeof ImageSize[keyof typeof ImageSize];


export function instanceOfImageSize(value: any): boolean {
    for (const key in ImageSize) {
        if (Object.prototype.hasOwnProperty.call(ImageSize, key)) {
            if (ImageSize[key as keyof typeof ImageSize] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ImageSizeFromJSON(json: any): ImageSize {
    return ImageSizeFromJSONTyped(json, false);
}

export function ImageSizeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImageSize {
    return json as ImageSize;
}

export function ImageSizeToJSON(value?: ImageSize | null): any {
    return value as any;
}

export function ImageSizeToJSONTyped(value: any, ignoreDiscriminator: boolean): ImageSize {
    return value as ImageSize;
}

